// Ask Nexus open state. Every route mounts its own Layout, so the panel
// remounts on navigation; keeping "open" here (module scope, this tab only)
// lets the panel stay open when a source link inside it opens a record.
//
// Anything can open the panel with the window event `nexus:ask-open`
// (the palette, the top bar, a page) or with Ctrl/⌘+J.

export const ASK_NEXUS_OPEN_EVENT = "nexus:ask-open";
export const ASK_NEXUS_CLOSE_EVENT = "nexus:ask-close";

let open = false;

export const isAskNexusOpen = () => open;

export const rememberAskNexusOpen = (value) => {
  open = Boolean(value);
};

// The coach section to show on open ("today", "week", "recap", "followups",
// "ask", "memory"). The panel reads it once when it mounts and listens for
// later requests while it is open.
let requestedTab = null;

/** The section asked for by the last open, without clearing it. */
export const peekRequestedTab = () => requestedTab;

/** The section asked for by the last open, cleared once read. */
export const takeRequestedTab = () => {
  const tab = requestedTab;
  requestedTab = null;
  return tab;
};

/** Open the panel from anywhere, optionally on one coach section. */
export const openAskNexus = (tab = null) => {
  open = true;
  requestedTab = tab;
  window.dispatchEvent(
    new CustomEvent(ASK_NEXUS_OPEN_EVENT, { detail: { tab } }),
  );
};
